module.exports = __webpack_public_path__ + "static/media/brain.3c5f9893.jpeg";